<h1 class="mb-2 modal-header">Edit client details</h1>
<div>
	<app-edit-client [id]="id"></app-edit-client>
</div>
